import React from 'react';
import { Switch, Route } from 'react-router-dom';
import DashboardContainer from '../containers/dashboardContainer';

export default ({ match }) => (
  <Switch>
    <Route exact path={`${match.path}`} component={DashboardContainer} />
  </Switch>
)
